import React from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';

const DateGauge = ({ measurementData }) => (
  <div>
    <div className="text-xl font-semibold">
      {measurementData?.date_value
        ? dayjs(measurementData?.date_value).format('D MMM BBBB')
        : '-'}
    </div>
  </div>
);

DateGauge.propTypes = {
  measurementData: PropTypes.object,
};

export default DateGauge;
